<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Separation Type"
      text="Edit Separation Type"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localSeparationType.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"     
                outlined           
                label="Name"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      separationType: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localSeparationType: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (value) this.localSeparationType = { ...this.separationType }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.hrisSeparationTypes().update(this.localSeparationType.id, { name: this.localSeparationType.name })
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(error => {
                if (error.response.status === 500) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.status, 
                  })      
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
    },
  }
</script>
